import { useEffect, useRef, useMemo } from "react";
import { useThree } from "@react-three/fiber";

import * as THREE from "three";

import gsap from "gsap";

const SceneOne = ({ level, setWorldPosition }) => {
  const ref = useRef();

  const loader = new THREE.TextureLoader();
  const width = window.innerWidth;
  const height = window.innerHeight;
  const aspect = width / height;
  const { scene } = useThree();

  // const [worldPosition, setWorldPosition] = useState({left: {x:0,y:0,z:0}, right: {x:0, y:0, z:0}})
  // const leftOval = loader.load("Egg shap.png");
  const leftOval = useMemo(
    () =>
      loader.load("Egg shap.webp", function (data) {
        leftOval.colorSpace = THREE.SRGBColorSpace;
        leftOval.minFilter = THREE.LinearFilter;
        var tex = leftOval.clone();

        tex.needsUpdate = true;
      }),
    []
  );

  const rightSquare = useMemo(
    () =>
      loader.load("Ractangle.webp", function (data) {
        rightSquare.colorSpace = THREE.SRGBColorSpace;
        rightSquare.minFilter = THREE.LinearFilter;
        var tex = rightSquare.clone();

        tex.needsUpdate = true;
      }),
    []
  );

  useEffect(() => {
    return () => {
      scene.traverse(function (child) {
        if (child instanceof THREE.Mesh) {
          child.material.dispose();
        }
      });
    };
  }, []);

  useEffect(() => {
    if (ref.current && (level === 1 || level === 2)) {
      LeftRighBack();
    }
  }, [level]);

  function LeftRighBack() {
    var vector = new THREE.Vector2();

    vector.x = ((vector.x / 2) * window.innerWidth) / window.innerHeight;
    vector.y = ((-vector.y / 2) * window.innerHeight) / window.innerHeight;

    if (ref.current) {
      gsap.to(ref.current.children[0].position, {
        x: vector.x - aspect * 2,
        y: vector.y,
        onComplete: () => {
          const position = new THREE.Vector3();
          ref.current.children[0].getWorldPosition(position);
          const xPosition = ref.current.children[0].scale.x - position.x;

          setWorldPosition((prev) => ({
            ...prev,
            left: position,
            middle: new THREE.Vector3(0, 0, 0),
          }));
        },
      });
      gsap.to(ref.current.children[1].position, {
        x: vector.x + aspect * 2,
        y: vector.y,
        onComplete: () => {
          const position = new THREE.Vector3();
          ref.current.children[1].getWorldPosition(position);

          const xPosition = ref.current.children[1].scale.x - position.x;
          setWorldPosition((prev) => ({
            ...prev,
            right: { x: xPosition, y: position.y, z: position.z },
          }));
        },
      });
    }

    return vector;
  }

  const { viewport: v, aspect: aspectt } = useThree();

  function useAspect(width, height, factor = 0.12) {
    const adaptedHeight =
      height * (aspectt > width / height ? v.width / width : v.height / height);
    const adaptedWidth =
      width * (aspectt > width / height ? v.width / width : v.height / height);

    return [adaptedWidth * factor, adaptedHeight * factor, 1];
  }

  const [aspectWeight, aspectHeight] = useAspect(
    window.innerWidth,
    window.innerHeight
  );

  return (
    <group ref={ref}>
      <mesh scale={[aspectWeight * 2, aspectWeight * 2, 1]}>
        <sprite>
          <spriteMaterial attach={"material"} map={leftOval} />
        </sprite>
      </mesh>

      <mesh scale={[aspectWeight * 3.5, aspectWeight * 3.5, 1]}>
        <sprite>
          <spriteMaterial attach={"material"} map={rightSquare} />
        </sprite>
      </mesh>
    </group>
  );
};

export default SceneOne;
